import React, { useState, useRef, useEffect, ReactNode } from "react";
import { MdKeyboardArrowDown } from "react-icons/md";
import useUserLogin from "../../hooks/UserLoginhook";

interface CustomDropdownProps {
  options: { label?: string; value: string }[];
  onSelect: (value: string) => void;
}

const ReportStatusCustomDropdown: React.FC<CustomDropdownProps> = ({
  options,
  onSelect,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState<ReactNode>(
    options.find((option) => option.value === "AVAILABLE")?.label || "AVAILABLE"
  );
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  const { customColor } = useUserLogin();
  const dropdownRef = useRef<HTMLDivElement | null>(null);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleSelect = (value: string) => {
    const selectedLabel = options.find(
      (option) => option.value === value
    )?.label;
    setSelected(selectedLabel || "AVAILABLE");
    onSelect(value);
    setIsOpen(false);
    setHoveredIndex(null);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  return (
    <div className="relative w-80 pl-2 font-sans" ref={dropdownRef}>
      <div
        className="border border-gray-300 rounded-md p-2 cursor-pointer bg-white hover:bg-gray-100 flex items-center justify-between text-custom-petite h-[30px]"
        onClick={toggleDropdown}
      >
        <div className="flex items-center gap-2">{selected}</div>
        <MdKeyboardArrowDown />
      </div>
      {isOpen && (
        <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg">
          <div className="flex flex-col">
            {options.map((option, index) => (
              <div
                key={option.value}
                style={{
                  backgroundColor:
                    hoveredIndex === index ? customColor : "transparent",
                  transition: "background-color 0.3s",
                }}
                className="flex items-center p-2 gap-2 hover:bg-custom-default-hover hover:rounded-md hover:text-white cursor-pointer text-custom-petite"
                onClick={() => handleSelect(option.value)}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                {option.label}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ReportStatusCustomDropdown;
